/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # UI utils

define('global/UI/Core',[
    'jquery',
    'lodash',
    'global/Core',
    'global/EventManager',
    'global/Logger',
    'global/Constants',
    'handlebars',
    './Modal',
    'plugins/toastr',
    'plugins/jquery.blockUI',
    '../../../../dist/templates',
    '../GoogleMapsLoader',
    'plugins/magnific-popup',
    'plugins/jquery.addresscomplete',
    'plugins/jquery.ziplookup'
], function ($, _, Core, EventManager, Logger, Constants, Handlebars, Modal, Toastr, blockUI, RocTemplates, GoogleMapsLoader) {
    'use strict';

    var $siteBody = $('body');

    // Binds 'Please Wait' messaging to non-function driven actions such as links
    $siteBody.on('click', '[data-roc-lock="true"], .btnCompareItems', function (e) {
        Core.lockButton(e.currentTarget);
    });

    // Confirm Plugin
    $.confirm = function (params) {
        if ($('#confirmOverlay').length) {
            // A confirm is already shown on the page:
            return;
        }

        var buttonHTML = '';
        $.each(params.buttons, function (name, obj) {
            buttonHTML += "<button class='" + obj['class'] + "' type='button'>" + name + '</button>&nbsp;';
            if (!obj.action) {
                obj.action = function () { };
            }
        });

        var markup = [
            "<div id='confirmOverlay' class='white-popup'>",
            "<div class='modal-header'>",
                    "<h2 class='title'>", params.title, '</h2>',
                    '</div>',
            "<div id='confirmBox' class='modal-body'>",
                    '<p>', params.message, '</p>',
                    '</div>',
            "<div id='confirmButtons' class='modal-footer'>",
            buttonHTML,
                    '</div></div>'
        ].join('');

        Modal.open(markup);

        var buttons = $('#confirmButtons button'),
        i = 0;

        $.each(params.buttons, function (name, obj) {
            obj.autoClose = (obj.autoClose === undefined) ? true : obj.autoClose;
            buttons.eq(i++).click(function () {
                obj.action();
                if (obj.autoClose) {
                    $.confirm.hide();
                }
                return false;
            });
        });
    };

    $.confirm.hide = function () {
        $.magnificPopup.close();
        $('#confirmOverlay').remove();
    }

    function scrollTo(sel, offset) {
        $('html,body').animate({
            scrollTop: $(sel).offset().top + offset
        }, 'fast');
    }

    function attachEventHandler(eventName, selector, handlerFunc) {
        $(document)
            .off(eventName, selector)
            .on(eventName, selector, _.debounce(handlerFunc, 300));
    }

    /* Returns html content based on selected template
       and context passed - proxy to handlebars
    ----------------------------------------------------*/

    RocTemplates = RocTemplates || {};
    Handlebars.templates = RocTemplates;
    Handlebars.partials = RocTemplates;

    var templateCache = {};
    var productionMode = Core.checkSiteMode();
    var templateDir = '/ResourcePackages/Roc/assets/src/templates';

    /**
     * renderPromise() returns a promise that includes the requested template markup
     * based on the passed template file name on data context
     *
     * @param {string} templateName
     * @param {object} templateData
     * @return {promise} promise.promise()
     */

    function renderPromise(templateName, templateData) {
        templateCache = templateCache || {};

        var promise = $.Deferred();
        var templatePath = 'assets/src/templates/' + templateName + '.html';

        if (productionMode === true) {
            //use precompiled templates.
            Logger.debug('Get Precompiled Template: ', templateName);
            promise.resolve(RocTemplates[templatePath](templateData));
        } else if (!(templateCache[templateName] && 'function' === typeof templateCache[templateName])) {
            Logger.debug('Get Fresh Template:', templateName);

            var templateUrl = templateDir + '/' + templateName + '.html';
            var templateString = '';

            $.ajax({
                url: templateUrl,
                method: 'GET',
                async: true,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                success: function (data) {
                    templateString = data;
                    templateCache[templateName] = Handlebars.compile(templateString);
                    promise.resolve(templateCache[templateName](templateData));
                },
                fail: function () {
                    promise.reject('Unable to load template: ' + templateName);
                }
            });
        } else {
            //use cached templates.
            Logger.debug('Cached Template: ', templateName);
            promise.resolve(templateCache[templateName](templateData));
        }

        return promise.promise();
    };

    /**
     * renderSynchronously() returns the html markup based on the passed template file name on data context processed via handlebarsJS
     * This method does the initial ajax request sychronously
     *
     * @param {string} templateName
     * @param {object} templateData
     * @return {html} templateCache[templateName](templateData);
     */
    function renderSynchronously(templateName, templateData) {
        templateCache = templateCache || {};

        var templatePath = 'assets/src/templates/' + templateName + '.html';

        if (productionMode === true) {
            //use precompiled templates.
            templateCache[templateName] = RocTemplates[templatePath];
            Logger.debug('Get Precompiled Template [rs]: ', templateName);
        } else if (!(templateCache[templateName] && 'function' === typeof templateCache[templateName])) {
            Logger.debug('Get Fresh Template [rs]:', templateName);

            var templateUrl = templateDir + '/' + templateName + '.html';
            var templateString = '';

            $.ajax({
                url: templateUrl,
                method: 'GET',
                async: false,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                success: function (data) {
                    templateString = data;
                    templateCache[templateName] = Handlebars.compile(templateString);
                },
                fail: function () {
                    Logger.debug('Unable to load template: ' + templateName);
                }
            });
        }

        return templateCache[templateName](templateData);
    }

    /**
     * template() returns a promise that includes the requested template markup
     * based on the passed template file name on data context
     *
     * @param {string} templateName
     * @param {object} context
     * @param {boolean} isSynchronous
     * @return {html} renderOutput
     */
    function template(templateName, context, isSynchronous) {
        var renderOutput;

        if ((/^#/).test(templateName)) {
            templateName = templateName.substring(1);
        }

        if (isSynchronous === true) {
            renderOutput = renderSynchronously(templateName, context);
        } else {
            renderOutput = renderPromise(templateName, context);
        }

        return renderOutput;
    }

    function renderFormTemplate(templateName, context, outputContainer, isSynchronous)
    {
        var deferred = $.Deferred();

        template(templateName, context, isSynchronous)
            .then(function(renderedTemplate) {
                outputContainer.html(renderedTemplate);
                EventManager.notify(Constants.events.templates.RENDER_FORM_COMPLETED, { templateName: templateName, outputContainer: outputContainer, renderedTemplate: renderedTemplate });
                deferred.resolve();
            });

        return deferred.promise();
    }

    // TODO: Deprecated - Needs to be removed in a future version since it has been superseded by the above template() method
    function templateV2(templateName, context) {
        Logger.warn('templateV2() has been deprecated. Should utilize template() instead.')
        return template(templateName, context, true);
    }


    /* Adjusts diplay of state and region based on
       selected country
    ----------------------------------------------------*/

    function updateRegionStateDisplay(addressType) {
        var $country = $('#' + addressType + '-country');
        var $region = $('#' + addressType + '-region-wrapper');
        var $state = $('#' + addressType + '-state-wrapper');

        if ($country.val() === 'US' || $country.val() === 'CA') {
            $state.show();
            $region.hide();
            $('#' + addressType + '-region').val('');
            $state.find('[data-country]').hide();
            $state.find('[data-country=' + $country.val() + ']').show();
        } else {
            $state.hide();
            $region.show();
        }
    }

    function countryChangeEvt(addressType) {
        var selector = '#' + addressType + '-country';
        var eventWithNamespace = 'change.core-countryChangeEvt';

        $(document)
            .off(eventWithNamespace, selector)
            .on(eventWithNamespace, selector, function () {
                var countryCode = $(this).val();
                $('#' + addressType + '-state').val('');
                updateRegionStateDisplay(addressType);
                bindAddressAutoCompleteEvt(addressType, null, countryCode);
                bindZipCodeLookUpEvt(addressType, null, countryCode);
            });
    }

    /* Wrapper functions for $.addresscomplete and $.ziplookup plugins */
    /* making sure Google Maps API is loaded before plugin is used */

    function addresscomplete(elem, options) {
        // make sure Google Maps API is loaded
        GoogleMapsLoader.loadApi().then(function () {
            $(elem).addresscomplete(options);
        });
    }

    function disableAddressComplete(elem) {
        GoogleMapsLoader.loadApi().then(function () {
            $(elem).disableAddressComplete();
        });
    }

    function ziplookup(elem, options) {
        GoogleMapsLoader.loadApi().then(function () {
            $(elem).ziplookup(options);
        });
    }
    
    /* Autocomplete for common adress related forms
    ----------------------------------------------------*/
    function bindAddressAutoCompleteEvt(addrType, callback, country) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true){
            return;
        }

        country = country || window.RocConfig.defaultCountryCode;
        addresscomplete('#' + addrType + '-address1', {
            country: country,
            callback: callback,
            autopopulate: true,
            fieldsMapping: {
                "STREET_ADDRESS_AND_NUMBER": '#' + addrType + '-address1',
                "COUNTRY": '#' + addrType + '-country',
                "ZIP": '#' + addrType + '-zip',
                "CITY": '#' + addrType + '-city',
                "STATE_OR_REGION": (country === 'US' || country === 'CA') ? '#' + addrType + '-state' : '#' + addrType + '-region'
            }
        });
    }

    // Init zip code lookup plugin for zip/postal field and provide mapping for city/state
    function bindZipCodeLookUpEvt(addrType, callback, country) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true) {
            return;
        }
        country = country || window.RocConfig.defaultCountryCode;
        ziplookup('#' + addrType + '-zip', {
            country: country,
            callback: callback,
            fieldsMapping: {
                "CITY":'#' + addrType + '-city',
                "STATE_OR_REGION": (country === 'US' || country === 'CA') ? '#' + addrType + '-state' : '#' + addrType + '-region'
            }
        });
    }

    function bindAddressFormEvents(addrType, addressAutoCompleteCallback, zipCodeLookCallback) {
        countryChangeEvt(addrType);
        bindAddressAutoCompleteEvt(addrType, addressAutoCompleteCallback);
        bindZipCodeLookUpEvt(addrType, zipCodeLookCallback);
    }

    function swapButtons(btns, newSelected, groupSelector) {
        var $newSelected = $(newSelected);
        var $oldSelected;
        if (typeof groupSelector !== 'undefined') {
            if (newSelected) {
                $oldSelected = $newSelected.closest(groupSelector).find('.' + btns.btnSelected.cssClass);
            } else {
                $oldSelected = $(groupSelector).find('.' + btns.btnSelected.cssClass);
            }

        } else {
            $oldSelected = $('.' + btns.btnSelected.cssClass);
        }
        template('btnChecked-Tmp', btns.btnSelected).then(function (renderedTemplate) {
            $(newSelected).replaceWith(renderedTemplate);
        });

        template('btnUseThis-Tmp', btns.btnUseThis).then(function (renderedTemplate) {
            $oldSelected.replaceWith(renderedTemplate);
        });
    }

    /**
     * Passing groupSelector param you can restrict buttons to swipe only to a given container area
     * @param {} btns 
     * @param {} callback 
     * @param {} groupSelector 
     * @returns {} 
     */
    function btnUseThisClickEvt(btns, callback, groupSelector) {
        var useThisCssClass = btns.btnUseThis.cssClass;
        var selectedCssClass = btns.btnSelected.cssClass;

        var selector = '.' + useThisCssClass;

        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                var $this = $(this);
                if ($this.hasClass(selectedCssClass)) {
                    return;
                }

                var btnSelected = this;
                var id = getItemId(btnSelected);
                var $closestItem = $this.closest('.item');

                swapButtons(btns, btnSelected, groupSelector);

                if (typeof (callback) === 'function') {
                    callback(id, $closestItem);
                }
            });
    }

    function getItemId(element) {
        return $(element).closest('.item').attr('data-id');
    }

    function closeForm(formSelector) {
        $(formSelector).collapse({ toggle: false });
        $(formSelector).collapse('hide');
    }

    function openForm(formSelector) {
        $(formSelector).collapse({ toggle: false });
        $(formSelector).collapse('show');
    }

    function onCloseFormEvt(formSelector, callback) {
        $(document).on('hidden.bs.collapse', formSelector, function () {
            if (typeof (callback) === 'function') {
                callback(this);
            }
        });
    }

    function onOpenFormEvt(formSelector, callback) {
        $(document).on('shown.bs.collapse', formSelector, function () {
            if (typeof (callback) === 'function') {
                callback(this);
            }
        });
    }

    function checkEmptyResultsDisplay(context) {
        if (!context.listSelector || !context.emptyResultsSelector) {
            return;
        }

        if ($(context.listSelector + ' .item').length > 0) {
            $(context.emptyResultsSelector).hide();
        } else {
            $(context.emptyResultsSelector).show();
        }
    };

    function removeItemFromUi(editId, context) {
        if (!context.listSelector || !context.btns) {
            return;
        }

        $(context.listSelector + ' .item[data-id=' + editId + ']').hide('slow', function () {
            var isDefault = $(this).find('.btn.' + context.btns.btnSelected.cssClass).length > 0;
            $(this).remove();
            checkEmptyResultsDisplay(context);
            if (isDefault) {
                swapButtons(context.btns, context.listSelector + ' .item:first .' + context.btns.btnUseThis.cssClass);
            }
        });
    };

    function countCharactersLeft(elemSelector) {
        var $textarea = $(elemSelector);
        if ($textarea.length === 1 && $textarea.attr('maxlength') !== null) {
            var maxLength = $textarea.attr('maxlength');
            var remaining = (maxLength - (parseInt($textarea.val().replace(/(\r\n|\n|\r)/gm, '\r\n').length)));
            return remaining;
        }

        Logger.warn('UI.countCharactersLeft: Element (' + elemSelector + ") wasn't found or is missing maxlength attribute");
        return null;
    }


    /* Validation related functions 
    ---------------------------------------------------------------------------*/

    var errorCssClass = 'formee-error';
    var errorMsgCssClass = 'formee-msg-error';
    var errorSummaryCssClass = 'errorSummary';
    var formWrapperCssClass = 'formee';

    /**
     * getErrorSummaryWrapper() checks to see if the error summary wrapper exists within the context of the past selector object
     * If it does, the element is returned as a jquery object. If not, the element will be first prepended to the passed context
     * and then will be returned
     *
     * @param {object} $formWrapper
     * @return {object} $errorWrapper
     */
    function getErrorSummaryWrapper($formWrapper) {
        var $errorWrapper = $formWrapper.find('[data-roc-error]');

        if ($errorWrapper.length === 0) {
            $errorWrapper = $formWrapper.prepend('<div data-roc-error="true">').find('[data-roc-error]');
        };

        return $errorWrapper;
    };

    function showFormFieldError(f) {
        var $field = $(f.Field);
        var fieldMsgId = 'describe-' + $field[0].id;

        switch (f.Type) {
            case 'Text':
            case 'Textarea':
            case 'Select':
            case 'Range':
                $field.addClass(errorCssClass).attr('aria-describedby', fieldMsgId);
                $('label[for=' + $(f.Field).attr('id') + ']').addClass(errorCssClass);

                if (f.ErrorMsg !== undefined) {
                    if ($field.closest('.formee-group, .roc-form-group').length > 0) {
                        $field.closest('.formee-group, .roc-form-group').after($('<p class="' + errorMsgCssClass + '" data-for="' + f.Field + '">' + f.ErrorMsg + '</p>'));
                    } else {
                        $('<p id="' + fieldMsgId + '" class="' + errorMsgCssClass + '" data-for="' + f.Field + '">' + f.ErrorMsg + '</p>').insertAfter(f.Field);
                    };
                }
                break;
            case 'Rating':
                $field.addClass(errorCssClass).attr('aria-describedby', fieldMsgId);
                $('label[for=' + $(f.Field).attr('id') + ']').addClass(errorCssClass);
                break;
            case 'Radiolist':
                $field.addClass(errorCssClass);
                $field.closest('fieldset').find("input,label").addClass(errorCssClass);

                if (f.ErrorMsg !== undefined) {
                    if ($field.closest('.formee-group, .roc-form-group').length > 0) {
                        $field.closest('.formee-group, .roc-form-group').after($('<p class="' + errorMsgCssClass + '" data-for="' + f.Field + '">' + f.ErrorMsg + '</p>'));
                    } else {
                        $('<p id="' + fieldMsgId + '" class="' + errorMsgCssClass + '" data-for="' + f.Field + '">' + f.ErrorMsg + '</p>').insertAfter(f.Field);
                    };
                }
                break;
            case 'Hidden':
                if (f.ErrorMsg !== undefined) {
                    $field.parent('.' + formWrapperCssClass).find('.' + errorSummaryCssClass).append(f.ErrorMsg);
                }
                break;
            case 'Checkbox':
                var labelElement = $('label[for=' + $(f.Field).attr('id') + ']');
                $field.addClass(errorCssClass).attr('aria-describedby', fieldMsgId);
                labelElement.addClass(errorCssClass);
                if (f.ErrorMsg !== undefined) {
                    if (labelElement.length) {
                        labelElement.append('<p id="' + fieldMsgId + '" class="' + errorMsgCssClass + '" data-for="' + f.Field + '"><br />' + f.ErrorMsg + '</p>');
                    }
                    else {
                        $('<p id="' + fieldMsgId + '" class="' + errorMsgCssClass + '" data-for="' + f.Field + '"><br / >' + f.ErrorMsg + '</p>').insertAfter(f.Field);
                    }
                }
                break;
        }
    }

    function clearFormErrors(form) {
        // Clear validation error for currently processed form
        $(form.Fields[0].Field).closest('.' + formWrapperCssClass).find('.' + errorSummaryCssClass).remove();

        // Remove field error for all form fields
        _(form.Fields).forEach(function (f) {
            switch (f.Type) {
                case 'Radiolist':
                    $(f.Field).removeClass(errorCssClass);
                    $(f.Field).closest('fieldset').find("input,label").removeClass(errorCssClass);
                    $('.' + errorMsgCssClass + '[data-for="' + f.Field + '"]').remove();
                    break;
                default:
                    $(f.Field).removeClass(errorCssClass).removeAttr('aria-describedby');
                    $('label[for=' + $(f.Field).attr('id') + ']').removeClass(errorCssClass);
                    $('.' + errorMsgCssClass + '[data-for="' + f.Field + '"]').remove();
                    break;
            }
        });
    }

    function clearFormErrorSummary(form) {
        $(form.Fields[0].Field).closest('.' + formWrapperCssClass).find('.' + errorSummaryCssClass).remove();
    }

    function showFormErrorSummary(form) {
        clearFormErrorSummary(form);
        var errors = [];
        _.forEach(form.Fields, function (f) {

            if (!f.isValid && f.ExcludeFromErrorSummary !== true) {
                if (f.ErrorMsg) {
                    errors.push({
                        id: f.Field,
                        error: f.ErrorMsg
                    });
                }
            }
        });

        if (errors.length > 0) {
            
            var $wrapper = $(errors[0].id).closest('.formee');
            var $errorWrapper = getErrorSummaryWrapper($wrapper);

            template('formErrorSummary-Tmp', { errors: errors }).then(function (renderedTemplate) {
                var scrollPos = 0;

                $errorWrapper.prepend(renderedTemplate);

                if ($errorWrapper.length > 0) {
                    scrollPos = $errorWrapper.eq(0).offset().top - 75;
                };

                $('html, body').scrollTop(scrollPos);
            });
        }
    };

    function showFormErrorInlineMsgs(form) {
        clearFormErrors(form);
        var errors = [];
        var $field = $(f.Field);

        _.forEach(form.Fields, function (f) {
            if (!f.isValid) {
                var inlinetmpl = {};
                if (f.ErrorMsg) {
                    errors.push(f.ErrorMsg);
                    inlinetmpl = templateV2('#formErrorInlineMsg-Tmp', { errorText: f.ErrorMsg });
                }

                if (f.Type === 'Select') {
                    if ($field.addClass(errorCssClass).parent().parent().find('label').length === 0) {
                        $field.parent().parent().parent().find('label').addClass(errorCssClass).append(inlinetmpl);
                    } else {
                        $field.parent().parent().find('label').addClass(errorCssClass).append(inlinetmpl);
                    }
                } else {
                    $field.addClass(errorCssClass).parent().find('label').addClass(errorCssClass).append(inlinetmpl);
                }
            }
        });
    };

    /* UI popups displayed on page - proxy to toastr.js
      -> in case we will want to replace that with somethig else
      -> maybe we will want to add additional stuff like logging
      toastr demo http://codeseven.github.io/toastr/demo.html
    -------------------------------------------------------------*/

    function info(message, title) {
        Toastr.info(message, title);
    }

    function error(message, title) {
        Toastr.error(message, title);
    }

    function warning(message, title) {
        Toastr.warning(message, title);
    }

    function success(message, title) {
        Toastr.success(message, title);
    }

    /**
     * Page Blocking / Ajax Loading UI
     * This leverages jquery.blockUI.js
     * @param {String} target [optional]
     * Documentation: http://malsup.com/jquery/block/ 
     */
    $.blockUI.defaults.css = {};

    function block(target) {
        var messageHtml = '<div class="roc-waiting-content" id="roc-waiting-content" role="alert" aria-live="polite">';
        messageHtml += '    Please Wait...';
        messageHtml += '    <span class="visually-hidden">updating content</span>';
        messageHtml += '    <div class="loading-squares">';
        messageHtml += '        <span></span><span></span><span></span><span></span><span></span>';
        messageHtml += '    </div>';
        messageHtml += '</div>';

        var blockOptions = {
            message: messageHtml,
            css: {},
            centerX: false,
            centerY: false,
            blockMsgClass: 'blockMsg roc-waiting'
        }

        if (typeof target == 'undefined' || target === null) {
            // if no target is supplied then block entire page
            $.blockUI(blockOptions);
        } else {
            var $target = $(target);

            if ($target.length === 0) {
                Logger.debug("Function Roc.UI.block: Target selector doesn't exist in DOM. Blocking page instead");
                $.blockUI(blockOptions);
            } else {
                $target.wrap('<div class="roc-block-container"></div>');
                $target.parent('.roc-block-container').block(blockOptions);
            };
        };
    };

    function unblock(target) {
        if (typeof target == 'undefined' || target === null) {
            // if no target is supplied then unblock entire page
            $.unblockUI();
        } else {
            var blockTarget = $(target);
            var blockTargetParent = blockTarget.parent();

            if (blockTargetParent.is(".roc-block-container")) {
                blockTargetParent.unblock({
                    onUnblock: function () {
                        blockTarget.unwrap();
                    }
                });
            };
        };
    }


    // confirm modal messaging
    function confirm(options, yesCallback, noCallback) {
        if (!noCallback) {
            noCallback = function () { }
        }
        if (typeof options == 'string') {
            $.confirm({
                "title": 'Delete Confirmation',
                "message": options,
                "buttons": {
                    "Yes": {
                        "class": 'btn btnAction',
                        "action": yesCallback
                    },
                    "No": {
                        "class": 'btn',
                        "action": noCallback
                    }
                }
            });
        } else {
            $.confirm(options);
        }
    };

    function displayErrorPopup(message, title) {
        confirm({
            "title": title || 'Oops!',
            "message": message || 'Internal system error. Please try again later.',
            "buttons": {
                "Ok": {
                    "class": 'btn btnDefault'
                }
            }
        });
    }

    function displayApiErrorPopup(baseApiResponse) {
        var title = baseApiResponse.message || 'There seems to be a problem';
        var errorMsg = '';
        if (baseApiResponse.errors && baseApiResponse.errors.length > 0) {
            $.each(baseApiResponse.errors, function (i, e) {
                errorMsg += e.relatedFieldName ?
                        '<br />' + e.relatedFieldName + ': ' + e.errorMessage :
                        '<br />' + e.errorMessage;
            });
        }
        displayErrorPopup(errorMsg, title);
    }

    function ajaxErrorPopup(xhr, message, title) {
        if (xhr.errors && xhr.errors.length > 0) {
            displayApiErrorPopup(xhr);
            return;
        }

        var errorMsg = message || 'Errors occurred during your request. Please try again later.';
        if (!message && xhr.status !== 500) {
            var response = xhr.responseJSON || {};
            if (response.exceptionMessage && typeof (response.exceptionMessage) == 'string') {
                errorMsg = response.exceptionMessage;
            } else if (response.message) {
                if (Core.isJson(response.message)) {
                    // Temp solution to handle non standard api resp like:
                    //{"Entity":null,"ResponseCode":"NotFound","Errors":null,"Message":"Requested order was not found. Please make sure your cookies are enabled."}
                    response = JSON.parse(response.message);
                    errorMsg = '<b>' + response.Message + '</b>';
                    if (response.Errors && response.Errors.length > 0) {
                        $.each(response.Errors, function (i, e) {
                            errorMsg += '<br />' + e.ErrorCode + ': ' + e.ErrorMessage;
                        });
                    }
                } else {
                    errorMsg = '<b>' + response.message + '</b>';
                    if (response.errors && response.errors.length > 0) {
                        $.each(response.errors, function (i, e) {
                            errorMsg += e.relatedFieldName ?
                                    '<br />' + e.relatedFieldName + ': ' + e.errorMessage :
                                    '<br />' + e.errorMessage;
                        });
                    }
                    if (response.modelState) {
                        for (var property in response.modelState) {
                            if (response.modelState.hasOwnProperty(property)) {
                                errorMsg += '<br />' + property + ': ' + response.modelState[property][0];
                            }
                        }
                    }
                }
            }
        }
        displayErrorPopup(errorMsg, title);
    }

    function formatRecipientLabel(recipient) {
        if (!recipient || (!recipient.firstName && !recipient.lastName && !recipient.city)) {
            return 'Myself';
        }

        var label = ((recipient.firstName || '') + ' ' + (recipient.lastName || '')).trim();
        if (recipient.city) {
            if (label.length > 0) {
                label += ' - ' + recipient.city;
            } else {
                label = recipient.city;
            }
        }
        return label;
    }

    var UI = {
        template: template,
        renderFormTemplate: renderFormTemplate,
        templateV2: templateV2,
        updateRegionStateDisplay: updateRegionStateDisplay,
        countryChangeEvt: countryChangeEvt,
        bindAddressAutoCompleteEvt: bindAddressAutoCompleteEvt,
        bindZipCodeLookUpEvt: bindZipCodeLookUpEvt,
        bindAddressFormEvents: bindAddressFormEvents,
        swapButtons: swapButtons,
        btnUseThisClickEvt: btnUseThisClickEvt,
        getItemId: getItemId,
        closeForm: closeForm,
        openForm: openForm,
        onCloseFormEvt: onCloseFormEvt,
        onOpenFormEvt: onOpenFormEvt,
        removeItemFromUi: removeItemFromUi,
        checkEmptyResultsDisplay: checkEmptyResultsDisplay,
        countCharactersLeft: countCharactersLeft,
        formatRecipientLabel: formatRecipientLabel,
        addresscomplete: addresscomplete,
        disableAddressComplete : disableAddressComplete,
        ziplookup : ziplookup,

        // Validation
        showFormFieldError: showFormFieldError,
        clearFormErrors: clearFormErrors,
        showFormErrorSummary: showFormErrorSummary,
        showFormErrorInlineMsgs: showFormErrorInlineMsgs,
        getErrorSummaryWrapper: getErrorSummaryWrapper,

        // Toast Notifications
        info: info,
        error: error,
        warning: warning,
        success: success,

        // Page / Section block loading
        block: block,
        unblock: unblock,

        // misc
        confirm: confirm,
        displayErrorPopup: displayErrorPopup,
        displayApiErrorPopup: displayApiErrorPopup,
        ajaxErrorPopup: ajaxErrorPopup,
        scrollTo: scrollTo,
        siteBody: $siteBody,
        attachEventHandler: attachEventHandler
    };

    Logger.debug('UI.js Loaded:', UI);

    return UI;
});
